import { useMemo, type ComponentProps } from "react";

import type { PlanStockTableFoLaptop } from "..";

type Props = ComponentProps<typeof PlanStockTableFoLaptop>;

export const usePlanStockTablePresenter = ({ serverModel, selectedItemIDs }: Props) => {
	const filteredViewModel = useMemo(() => {
		const { items } = serverModel.planStock;
		const filteredItems = items.filter((item) => selectedItemIDs.includes(item.planID));
		return { ...serverModel.planStock, items: filteredItems };
	}, [serverModel.planStock, selectedItemIDs]);

	const [currentYear, currentMonth] = filteredViewModel.headers[0].date.split("-");

	return {
		filteredViewModel,
		currentYear,
		currentMonth,
	};
};
